import React, { useContext } from 'react';
import InfoMessage from '.././InfoMessage';
import { filterSearchResults } from '../../data/utils/filterSearchResults';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { getLabel } from '../../data/labels';
import { useLiveData } from '../../live/LiveDataProvider';
import LiveBadge from '../LiveBadge';
import { urls } from '../..';
import { XRouterNavigateContext } from '../seo/xrouter/XRouterNavigateContext';

export default function LiveResults(props) {
    const xrouterNavigateContext = useContext(XRouterNavigateContext);
    const liveData = useLiveData();

    const filtered = filterSearchResults(liveData.matches, props.search, 'MATCH', function(match) {
        return match.desc;
    });

    if (filtered.length === 0) {
        return <InfoMessage message={getLabel('general.no_events')} />
    }

    function openEvent(e) {
        xrouterNavigateContext.navigate(`${urls.base}/${urls.live.base}/${urls.live.event}/${e.id}`, {data:e, state: e});
        props.toggle();
    }

    return (
        <>
            {filtered.map(e => {
                const iconClass = liveData.sportById[e.sportRef]?.categoryById[e.categoryRef]?.iconClass ?? null;
                const categoryIcon = iconCategoryCssClass(e.sportRef, e.categoryRef, iconClass);
                const desc = `${e.sportDesc} - ${e.tournamentDesc}`;
                return (
                    <div key={e.id} className="p-1 bg-cs1 flex flex-col justify-center border-b border-b-cs7" onClick={() => openEvent(e)}>
                        <div className="grid grid-cols-12">
                            <div className="col-start-1 col-end-2 h-full flex items-center">
                                <div className="p-1 flex flex-col justify-center border border-cs-9 rounded-md">
                                    <span className={"my-auto inline-block w-[24px] h-[24px] categoryIcon " + categoryIcon} />
                                </div>
                            </div>
                            <div className="col-start-2 col-end-13 pl-2 flex flex-col">
                                <div className="flex items-center">
                                    <span className="font-medium text-xs text-cs9 uppercase truncate">{e.time} | {desc}</span>
                                    <div className="ml-1 flex items-center"><LiveBadge /></div>
                                </div>
                                <span className="font-medium text-xs text-cs-10 truncate">{e.team1}</span>
                                <span className="font-medium text-xs text-cs-10 truncate">{e.team2}</span>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
}
